export default __webpack_public_path__ + "static/media/bitcoin.32a9393a.png";